import { ThemeProvider } from 'styled-components';

import { ThemeBasicType, ThemePropsType } from '../_declarations/theme';
import icons from '../MainTheme/icons';
import device from '../MainTheme/partials/device';
import colors from './colors';
import elevations from './elevations';
import fonts from './fonts';
import typography from './typography';

export const theme = {
  colors,
  device,
  elevations,
  fonts,
  icons,
  themeName: 'ds',
  typography
} as ThemeBasicType;

const Theme: React.FC<ThemePropsType> = ({
  children,
  extraProps,
  mediaQueries
}) => (
  <ThemeProvider theme={{ ...theme, extraProps, logos: {}, mediaQueries }}>
    {children}
  </ThemeProvider>
);

export default Theme;
